import { createPromise } from "./createPromise.js";
async function startDOMProcessing(params) {
  const { root, skipElementChildren, getComponentIdentity, logger } = params;
  logger.log("start processing DOM");
  let attempt = 0;
  let _controller;
  let mutateElementData = [];
  const rootElement = typeof root === "function" ? root() : root;
  while (attempt < 50) {
    _controller = new AbortController();
    try {
      await processDOMElements({
        getComponentIdentity,
        isRootLoop: true,
        logger,
        mutateElementData,
        resumeIndex: 0,
        rootElement,
        skipElementChildren
        // signal: controller.signal,
      });
      logger.success("finish processing DOM");
      return mutateElementData;
    } catch (e) {
      logger.warn(e, "restart processing DOM");
      attempt++;
      mutateElementData = [];
    }
  }
  logger.error("failed to process DOM");
}
async function processDOMElements(params) {
  const {
    logger,
    signal,
    isRootLoop,
    parentIndex = 0,
    resumeIndex = 0,
    rootElement,
    mutateElementData,
    skipElementChildren,
    getComponentIdentity
  } = params;
  const children = rootElement.children;
  const { resolver: stopBatch, promise: batchPromise } = createPromise(signal);
  requestIdleCallback((duration) => {
    const childBatches = [];
    for (let i = resumeIndex, n = children.length; i < n; i++) {
      if (signal?.aborted) {
        return;
      }
      if (isRootLoop && mutateElementData.length === 0) {
        const rect = rootElement.getBoundingClientRect();
        mutateElementData.push(getComponentIdentity(rootElement), -1, rect.top, rect.right, rect.bottom, rect.left);
      }
      if (duration.timeRemaining() > 0) {
        const element = children[i];
        if (!element) {
          throw new Error(`No child at ${i} (this should be a TS-only protection)`);
        }
        const isInvisible = globalThis.getComputedStyle(element).display === "none";
        if (isInvisible) {
          continue;
        }
        const rect = element.getBoundingClientRect();
        const identity = getComponentIdentity(element);
        const nextParentIndex = mutateElementData.length;
        mutateElementData.push(identity, parentIndex, rect.top, rect.right, rect.bottom, rect.left);
        const shouldSkipChildren = skipElementChildren(element, identity);
        if (!shouldSkipChildren) {
          childBatches.push(
            processDOMElements({
              getComponentIdentity,
              isRootLoop: false,
              logger,
              mutateElementData,
              parentIndex: nextParentIndex,
              resumeIndex: 0,
              rootElement: element,
              signal,
              skipElementChildren
            })
          );
        }
      } else {
        stopBatch({
          childBatches,
          resumeIndex: i,
          status: "paused"
        });
        return;
      }
    }
    stopBatch({
      childBatches,
      status: "done"
    });
  });
  const batchResult = await batchPromise;
  await Promise.all(batchResult.childBatches);
  if (batchResult.status === "done") {
    return;
  }
  return await processDOMElements({
    ...params,
    resumeIndex: batchResult.resumeIndex
  });
}
export {
  startDOMProcessing
};
//# sourceMappingURL=startDOMProcessing.js.map
